import { createStore } from 'vuex';

const auth = getAuth();

export const store = createStore({
    sate () {
        return {
            loaded: false,
            user: auth ? auth.user : null,
            company: null,
            city: auth ? auth.city : null,
            categories: [],
            cities: [],
            partners: [],
            platform: getPlatform(),
            navigated: 0,
        }
    },
    getters: {
        isClient(state) {
            return !!(state.user && state.user.type === 'client');
        },
        isMember(state) {
            return !!(state.user && state.user.type === 'member');
        },
        isLoggedIn(state) {
            return state.user !== null;
        },
        isNativeApp(state) {
            return state.platform !== null;
        },
        timesNavigated(state) {
            return state.navigated;
        },
    },
    mutations: {
        loaded(state) {
            state.loaded = true;
        },
        setUser(state, user) {
            state.user = user;
        },
        setCompany(state, company) {
            state.company = company;
        },
        setCity(state, city) {
            state.city = city;
        },
        updateCategories(state, payload) {
            state.categories = payload;
        },
        updateCities(state, payload) {
            state.cities = payload;
        },
        updatePartners(state, payload) {
            state.partners = payload;
        },
        addNavigation(state) {
            state.navigated = state.navigated + 1;
        },
        removeNavigation(state) {
            state.navigated = state.navigated - 1;
        },
    },
    actions: {
        setUser({commit}, user) {
            commit('setUser', user)
        },
        setCompany({commit}, company) {
            commit('setCompany', company)
        },
        setCity({commit}, city) {
            commit('setCity', city)
        },
        addNavigation({commit}) {
            commit('addNavigation');
        },
        removeNavigation({commit}) {
            commit('removeNavigation');
        },
        async getHighlightsForPosition({commit}, position) {
            const response = await axios.get(`/api/site/highlights?position=${position}`);
            return response.data;
        },
        async loadCategories(context) {
            const response = await axios.get('/api/site/categories');
            context.commit('updateCategories', response.data.data);
        },
        async loadCities({commit}) {
            const response = await axios.get('/api/site/cities');
            commit('updateCities', response.data.data);
        },
        async loadPartners({commit}) {
            const response = await axios.get('/api/site/partners');
            commit('updatePartners', response.data.data);
        },
        async initApp({dispatch, state, commit, getters}) {
            if (state.loaded) {
                return;
            }

            await dispatch('loadCategories');
            await dispatch('loadCities');
            await dispatch('loadPartners');

            if (getters.isClient) {
                const response = await axios.get('/api/client/company');
                dispatch('setCompany', response.data.data);
            }

            commit('loaded');
        }
    }
});
